const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  CAD: 'C$',
  EUR: '€',
  NOK: 'kr',
  GBP: '£',
};

/**
 * Get the currency symbol for a given currency code.
 * Defaults to $ (USD) if code is not recognized.
 */
export const getCurrencySymbol = (currencyCode: string | null | undefined): string => {
  if (!currencyCode) return '$';
  return CURRENCY_SYMBOLS[currencyCode] || '$';
};
